// src/pages/admin/adminPageEditor/components/EditorTabPanel.jsx
import React from "react";
import BusinessPage from "../../../layout/BusinessPage";
import EditorTab from "../../editorTabs/EditorTab";

export default function EditorTabPanel({
  mobileEditorView,
  setMobileEditorView,

  sections,
  limitsNormalized,
  onToggleSection,
  onMoveSection,
  onEditSection,
  onOpenTemplateSelector,
  onRemoveSection,
  onAddSection,

  nav,
  onOpenNavEditor,

  footer,
  onOpenFooterEditor,

  whatsapp,
  setWhatsapp,

  general,
  previewSlug,
}) {
  return (
    <>
      {/* mobile switcher */}
      <div className="lg:hidden bg-white rounded-2xl shadow-sm border p-2">
        <div className="grid grid-cols-2 gap-2">
          <button
            onClick={() => setMobileEditorView("controls")}
            className={
              "px-3 py-2 rounded-xl border text-sm font-semibold " +
              (mobileEditorView === "controls"
                ? "bg-gray-900 text-white border-gray-900"
                : "bg-white hover:bg-gray-50")
            }
          >
            Controls
          </button>
          <button
            onClick={() => setMobileEditorView("preview")}
            className={
              "px-3 py-2 rounded-xl border text-sm font-semibold " +
              (mobileEditorView === "preview"
                ? "bg-gray-900 text-white border-gray-900"
                : "bg-white hover:bg-gray-50")
            }
          >
            Preview
          </button>
        </div>
      </div>

      <div className="grid lg:grid-cols-5 gap-4 lg:gap-6">
        {/* left: controls */}
        <div className={"lg:col-span-2 min-w-0 " + (mobileEditorView === "controls" ? "block" : "hidden lg:block")}>
          <div className="bg-white rounded-2xl shadow-sm border p-4 sm:p-5">
            <EditorTab
              sections={sections}
              limits={limitsNormalized}
              onToggleSection={onToggleSection}
              onMoveSection={onMoveSection}
              onEditSection={onEditSection}
              onOpenTemplateSelector={onOpenTemplateSelector}
              onRemoveSection={onRemoveSection}
              onAddSection={onAddSection}
              nav={nav}
              onOpenNavEditor={onOpenNavEditor}
              footer={footer}
              previewSlug={previewSlug}
              onOpenFooterEditor={onOpenFooterEditor}
              whatsapp={whatsapp}
              setWhatsapp={setWhatsapp}
            />
          </div>
        </div>

        {/* right: preview */}
        <div className={"lg:col-span-3 min-w-0 " + (mobileEditorView === "preview" ? "block" : "hidden lg:block")}>
          <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
            <div className="p-4 sm:p-5 border-b">
              <div className="font-bold text-gray-900">Live Preview</div>
              <div className="text-sm text-gray-500">Click any section to edit it</div>
            </div>

            <div className="p-3">
              <div className="border-4 border-gray-200 rounded-2xl overflow-hidden">
                <BusinessPage
                  isPreview={true}
                  previewConfig={{ sections, footer, nav, whatsapp, general }}
                  slugOverride={previewSlug}
                  onSectionClick={(section) => onEditSection(section)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}